import { render, staticRenderFns } from "./LessonPodcast.vue?vue&type=template&id=cc77ac96&scoped=true&"
import script from "./LessonPodcast.vue?vue&type=script&lang=ts&"
export * from "./LessonPodcast.vue?vue&type=script&lang=ts&"
import style0 from "./LessonPodcast.vue?vue&type=style&index=0&id=cc77ac96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc77ac96",
  null
  
)

export default component.exports